import { useState } from "react";

import Bar from "../Common/Bar";
import DomesticHotelDetailCommentItem from "./DomesticHotelDetailCommentItem";
import DomesticHotelDetailCommentForm from "./DomesticHotelDetailCommentForm";
import HotelScore from "./HotelScore";

const DomesticHotelDetailComments = props => {

    const { reviewData } = props;
    const [showAllComments, setShowAllComments] = useState(false);
    const [openCommentForm, setOpenCommentForm] = useState(false);


    if (!reviewData) {
        return "no score Information"
    }

    return (
        <>
            <div className="clearfix margin-bottom">
                <h5 className="font-20 semi-bold pull-start margin-top no-margin-bottom">نظرات</h5>
                <button
                    type="button"
                    className="button blue-btn pull-end"
                    onClick={()=>{setOpenCommentForm(true)}}
                >
                    ثبت نظر
                </button>
            </div>

            {!!reviewData.reviews?.items?.length && <div className="card box-border margin-bottom bg-white card-padding">
                <div className="float-row large-gap">
                    <div className="col-small-12 col-medium-3">
                        <h5 className="small-title">امتیاز هتل از دید کاربران</h5>

                        <HotelScore
                            reviews={reviewData?.reviews.totalCount}
                            score={Math.floor(+reviewData.averageRating)}
                            className="semi-bold margin-bottom margin-top"
                            max={10}
                        />

                        {reviewData.ratings?.map(item => (
                            <div key={item.category?.name}>
                                <label className="font-13">
                                    {item.category?.name}
                                </label>
                                <Bar persentage={item.average * 10} className="block margin-bottom" />
                            </div>
                        ))}
                    </div>

                    <div className="col-small-12 col-medium-9">
                        <h5 className="small-title padding-bottom">نظرات کاربران</h5>

                        {reviewData.reviews.items.slice(0, 3).map(commentItem => <DomesticHotelDetailCommentItem key={commentItem.id} comment={commentItem} />)}

                        {showAllComments && reviewData.reviews.items.slice(3).map(commentItem => <DomesticHotelDetailCommentItem key={commentItem.id} comment={commentItem} />)}

                        {reviewData.reviews?.items?.length > 3 && <div className="text-center">
                            <button
                                type="button"
                                className="button blue-btn"
                                onClick={() => { setShowAllComments(prevState => !prevState) }}
                            >
                                مشاهده نظرات {showAllComments ? "کمتر" : "بیشتر"}
                            </button>
                        </div>}
                    </div>
                </div>
            </div>}

            {openCommentForm && (
                <div className="itours-modal visible" >
                    <div className="modal-overlay" onClick={() => { setOpenCommentForm(false) }} />
                    <div className="modal-inner medium-width">
                        <div className="modal-main no-height-limit">
                            <DomesticHotelDetailCommentForm pageId={props.pageId} closeForm={()=>{setOpenCommentForm(false)}} />
                        </div>
                    </div>
                </div>
            )}


        </>
    )
}

export default DomesticHotelDetailComments;